import { render, staticRenderFns } from "./Categor.vue?vue&type=template&id=3c627c10&"
import script from "./Categor.vue?vue&type=script&lang=js&"
export * from "./Categor.vue?vue&type=script&lang=js&"
import style0 from "./Categor.vue?vue&type=style&index=0&id=3c627c10&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports